export default "__VITE_ASSET__BkBn1Kt5__"